module.exports = __webpack_public_path__ + "static/media/yu_wen_liu.5d93493d.jpg";